module.exports = __webpack_public_path__ + "img/suture_wand.c1b7b5f.svg";